<template>
  <div class="paymentWrapper goldenbg">
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>
    <div class="pmBackBtn">
      <b-button
        class="pm-back-btn-ft"
        @click="$router.go(-1)"
      />
    </div>
    <b-row>
      <b-col cols="12">
        <div class="pmLogo floatCss">
          <img :src="pmLogoImg">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="pmtopBlock pmRpTittle floatCss">
          <p>This payment link will expire on <span>{{ dateFormatWithFormatParam(tokenDetail.expiresAt, 'DD MMM YYYY, hh:mma') }}</span>.</p>
          <h2><span>Total payment</span><span>${{ numberFormat(totalPayable) }}</span></h2>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showPayment">
      <b-col cols="12">
        <div class="paymentWhiteBlock floatCss">
          <validation-observer ref="paymentCardForm">
            <b-form
              class="paymentFormWrapper floatCss"
              @submit.prevent="submitFullForm"
            >
              <b-row>
                <b-col cols="12">
                  <div class="paymentinputSingle floatCss">
                    <validation-provider
                      #default="{ errors }"
                      name="Name on card"
                      rules="required"
                    >
                      <b-form-group
                        label="Name on card*"
                        label-cols-md="4"
                      >
                        <b-form-input
                          v-model="cardName"
                          placeholder="First name and last name"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="paymentinputSingle floatCss">
                    <validation-provider
                      #default="{ errors }"
                      name="Card number"
                      rules="required"
                    >
                      <b-form-group
                        label="Card number*"
                        label-cols-md="4"
                      >
                        <cleave
                          v-model="cardNumber"
                          class="form-control"
                          :raw="false"
                          :options="options.creditCard"
                          :state="(errors.length > 0 || cardNumberValidation) ? false : null"
                          placeholder="0000 0000 0000 0000"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="cardNumberValidation"
                          class="text-danger"
                        >{{ cardNumberError }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <div class="paymentinputSingle floatCss">
                    <validation-provider
                      #default="{ errors }"
                      name="Expiry Date"
                      rules="required"
                    >
                      <b-form-group
                        label="Expiry Date*"
                        label-cols-md="4"
                      >
                        <cleave
                          v-model="expiryDate"
                          class="form-control"
                          :raw="false"
                          :options="options.date"
                          :state="(errors.length > 0 || expiryDateValidation) ? false : null"
                          placeholder="mm/yyyy"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="expiryDateValidation"
                          class="text-danger"
                        >{{ expiryDateError }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="paymentinputSingle floatCss">
                    <validation-provider
                      #default="{ errors }"
                      name="CVV"
                      rules="required"
                    >
                      <b-form-group
                        label="CVV*"
                        label-cols-md="4"
                      >
                        <cleave
                          v-model="cvv"
                          class="form-control"
                          :raw="false"
                          :options="options.block"
                          :state="(errors.length > 0 || cvvValidation) ? false : null"
                          placeholder="3 digits"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="cvvValidation"
                          class="text-danger"
                        >{{ cvvError }}</small>
                      </b-form-group>
                    </validation-provider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="startBtnpm floatCss">
                    <b-button
                      class="sts-pm-btn"
                      type="submit"
                      :disabled="isButtonDisabled"
                    >
                      <span><img :src="dollarSignImg"></span> Confirm and pay
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loader from '../Loader.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,

    Cleave,
    Loader,

    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      pmLogoImg: require('@/assets/images/mobile/pmLogo.png'),
      // eslint-disable-next-line global-require
      dollarSignImg: require('@/assets/images/mobile/dollar-sign2.png'),
      showPayment: false,
      tokenDetail: {},
      submissionDetail: {},
      totalPayable: 0,
      omiseToken: '',

      cardName: '',
      cardNumber: '',
      cardNumberValidation: false,
      cardNumberError: 'Valid card number is required',
      expiryDate: '',
      expiryDateValidation: false,
      expiryDateError: 'Valid expiry date is required',
      cvv: '',
      cvvValidation: false,
      cvvError: 'Valid CVV is required',
      isButtonDisabled: false,
      pollTimer: null,

      options: {
        creditCard: { creditCard: true },
        date: { date: true, delimiter: '/', datePattern: ['m', 'Y'] },
        block: { blocks: [3], numericOnly: true },
      },

      required,
    }
  },

  beforeMount() {
    this.fetchPaymentDetail()
  },

  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer)
  },

  methods: {
    fetchPaymentDetail() {
      const { token } = this.$route.params
      this.$http.get('front-end/payment/validate/token', { params: { token } })
        .then(response => {
          if (response.data.success && response.data.type === 'sales' && response.data.validToken && !response.data.alreadyPaid) {
            this.showPayment = true
            this.submissionDetail = response.data.submission || {}
            this.tokenDetail = response.data.token || {}
            this.totalPayable = response.data.totalPayable || 0
            this.omiseToken = response.data.omiseToken
          } else {
            this.$router.replace({ name: 'file-payment-frontend-landing', params: { token } })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    submitFullForm() {
      this.$refs.paymentCardForm.validate().then(success => {
        this.cardNumberValidation = false
        this.expiryDateValidation = false
        this.cvvValidation = false
        let valid = true

        const trimmedCardNumber = this.cardNumber.trim().replace(/\s/g, '')
        if (trimmedCardNumber.length !== 16) {
          valid = false
          this.cardNumberError = 'Invalid card number'
          this.cardNumberValidation = true
        }

        const splittedExpiryDate = this.expiryDate.split('/')
        if (splittedExpiryDate.length !== 2 || splittedExpiryDate[0].length !== 2 || splittedExpiryDate[1].length !== 4) {
          valid = false
          this.expiryDateError = 'Invalid expiry date'
          this.expiryDateValidation = true
        }

        if (this.cvv.length !== 3) {
          valid = false
          this.cvvError = 'Invalid CVV'
          this.cvvValidation = true
        }

        if (!success || !valid) return

        this.isButtonDisabled = true
        const tokenParameters = {
          expiration_month: Number(splittedExpiryDate[0]),
          expiration_year: Number(splittedExpiryDate[1]),
          name: this.cardName,
          number: Number(trimmedCardNumber),
          security_code: Number(this.cvv),
        }

        // eslint-disable-next-line no-undef
        Omise.setPublicKey(this.omiseToken)
        // eslint-disable-next-line no-undef
        Omise.createToken('card', tokenParameters, (statusCode, response) => {
          if (statusCode === 200) {
            this.chargeCard(response.id, trimmedCardNumber.slice(-4))
          } else {
            this.isButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
      })
    },
    chargeCard(cardToken, cardNumberLast4) {
      const formData = new FormData()
      formData.append('token', this.$route.params.token)
      formData.append('url', window.location.origin)
      formData.append('cardToken', cardToken)
      formData.append('cardNumber', cardNumberLast4)
      formData.append('submissionID', this.submissionDetail._id)

      this.$http.post('front-end/payment/frontend/card/charge', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success && response.data.redirectURL) {
            window.open(response.data.redirectURL, '_self')
          } else if (response.data.success) {
            this.pollForCompletion()
          } else {
            this.isButtonDisabled = false
            this.$router.push({
              name: 'sales-payment-frontend-failed',
              params: { token: this.$route.params.token, message: response.data.message },
            })
          }
        })
        .catch(error => {
          this.isButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: (error.data && error.data.message) || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    pollForCompletion() {
      this.$store.commit('appConfig/UPDATE_LOADER', true)
      this.pollTimer = setInterval(() => {
        this.$http.get(`front-end/payment/token/${this.tokenDetail._id}/check/status`)
          .then(response => {
            if (response.data.success) {
              clearInterval(this.pollTimer)
              this.$store.commit('appConfig/UPDATE_LOADER', false)
              this.$router.push({ name: 'sales-payment-frontend-success', params: { token: this.$route.params.token } })
            } else if (response.data.failed) {
              clearInterval(this.pollTimer)
              this.$store.commit('appConfig/UPDATE_LOADER', false)
              this.$router.push({ name: 'sales-payment-frontend-failed', params: { token: this.$route.params.token } })
            }
          })
      }, 3000)
    },
  },
}
</script>
